import { Controller } from "remult";

@Controller("community-methods")
export class CommunityMethods {}
